export const constants = {
  filterOrder : "order",
  filterPart : "part",
  filterMachine : "machine"
}